(function () {
  function handleize(str) {
    str = String(str == null ? '' : str).toLowerCase();
    if (str.normalize) str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    str = str.replace(/[^a-z0-9\s-]/g, '');
    str = str.trim().replace(/\s+/g, '-').replace(/-+/g, '-');
    return str;
  }

  function parseMap(raw) {
    raw = String(raw || '').trim();
    if (!raw) return {};
    var out = {};
    raw.split(',').forEach(function (pair) {
      pair = String(pair || '').trim();
      if (!pair) return;
      var idx = pair.indexOf(':');
      if (idx === -1) return;
      var k = handleize(pair.slice(0, idx).trim());
      var v = handleize(pair.slice(idx + 1).trim());
      if (!k || !v) return;
      out[k] = v;
    });
    return out;
  }

  function invertMap(map) {
    var out = {};
    Object.keys(map || {}).forEach(function (k) {
      var v = map[k];
      if (v) out[v] = k;
    });
    return out;
  }

  function wrapperHasClassToken(wrapperEl, token) {
    if (!token) return false;
    var slides = wrapperEl.querySelectorAll('.swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('hc-' + token)) return true;
    }
    return false;
  }

  function resolveTokenToSlides(wrapperEl, token, mapA, mapB) {
    token = handleize(token);
    if (!token) return '';
    if (wrapperHasClassToken(wrapperEl, token)) return token;

    var a = mapA && Object.prototype.hasOwnProperty.call(mapA, token) ? mapA[token] : '';
    var b = mapB && Object.prototype.hasOwnProperty.call(mapB, token) ? mapB[token] : '';

    if (a && wrapperHasClassToken(wrapperEl, a)) return a;
    if (b && wrapperHasClassToken(wrapperEl, b)) return b;

    var invA = invertMap(mapA || {});
    var invB = invertMap(mapB || {});

    var ai = invA && Object.prototype.hasOwnProperty.call(invA, token) ? invA[token] : '';
    var bi = invB && Object.prototype.hasOwnProperty.call(invB, token) ? invB[token] : '';

    if (ai && wrapperHasClassToken(wrapperEl, ai)) return ai;
    if (bi && wrapperHasClassToken(wrapperEl, bi)) return bi;

    return token;
  }

  function hcRestoreWrapperFromTemplate(sliderEl) {
    var wrapperEl = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapperEl) return;
    var tpl = sliderEl.querySelector('template.hc-gallery-master');
    if (tpl && typeof tpl.innerHTML === 'string' && tpl.innerHTML.trim()) {
      wrapperEl.innerHTML = tpl.innerHTML;
      return;
    }
    if (!sliderEl.__hcFallbackMaster) sliderEl.__hcFallbackMaster = wrapperEl.innerHTML;
    wrapperEl.innerHTML = sliderEl.__hcFallbackMaster;
  }

  function filterSlides(wrapperEl, sizeVal, colorVal) {
    var slides = Array.prototype.slice.call(wrapperEl.querySelectorAll('.swiper-slide'));
    slides.forEach(function (slide) {
      var ok = true;
      if (sizeVal) ok = ok && slide.classList.contains('hc-' + sizeVal);
      if (colorVal) ok = ok && slide.classList.contains('hc-' + colorVal);
      if (!ok) slide.remove();
    });
  }

  function findVariantWraps() {
    return Array.prototype.slice.call(document.querySelectorAll('.variant-input-wrap'));
  }

  function getSelectedFromWrap(wrap) {
    if (!wrap) return '';
    var checked = wrap.querySelector('input[type="radio"]:checked');
    if (checked) {
      var vi = checked.closest('.variant-input');
      if (vi) {
        var dv = vi.getAttribute('data-default-value');
        if (dv) return handleize(dv);
      }
      if (checked.value) return handleize(checked.value);
    }
    var sel = wrap.querySelector('select');
    if (sel && sel.value) return handleize(sel.value);
    return '';
  }

  function detectIndexByName(keys) {
    var wraps = findVariantWraps();
    for (var i = 0; i < wraps.length; i++) {
      var label = wraps[i].getAttribute('data-index') || '';
      label = handleize(label);
      for (var j = 0; j < keys.length; j++) {
        if (label === keys[j]) return i;
      }
    }
    return -1;
  }

  function getSelectedByIndex(index) {
    var wraps = findVariantWraps();
    if (!wraps.length) return '';
    if (index < 0 || index >= wraps.length) return '';
    return getSelectedFromWrap(wraps[index]);
  }

  function initSwiper(sliderEl) {
    if (typeof Swiper === 'undefined') return null;
    return new Swiper(sliderEl, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      speed: 600,
      centeredSlides: true,
      autoHeight: true,
      pagination: { el: sliderEl.querySelector('.swiper-pagination') },
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev')
      },
      effect: 'fade',
      fadeEffect: { crossFade: true }
    });
  }

  function bootOne(sliderEl) {
    var wrapperEl = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapperEl) return;

    hcRestoreWrapperFromTemplate(sliderEl);

    var variantCount = parseInt(sliderEl.getAttribute('data-variants') || '0', 10);

    if (variantCount <= 1) {
      if (sliderEl.__hcSwiper && sliderEl.__hcSwiper.destroy) sliderEl.__hcSwiper.destroy(true, true);
      sliderEl.__hcSwiper = initSwiper(sliderEl);
      if (sliderEl.__hcSwiper && sliderEl.__hcSwiper.update) {
        sliderEl.__hcSwiper.update();
        sliderEl.__hcSwiper.slideTo(0, false);
      }
      sliderEl.classList.remove('hc-loading');
      sliderEl.__hcBootOne = function () { bootOne(sliderEl); };
      return;
    }

    var sizeIndex = sliderEl.hasAttribute('data-size-index') ? parseInt(sliderEl.getAttribute('data-size-index') || '0', 10) : -1;
    var colorIndex = sliderEl.hasAttribute('data-color-index') ? parseInt(sliderEl.getAttribute('data-color-index') || '0', 10) : -1;

    if (sizeIndex < 0) sizeIndex = detectIndexByName(['size', 'storrelse']);
    if (colorIndex < 0) colorIndex = detectIndexByName(['color', 'colour', 'farge']);

    var sizeVal = '';
    var colorVal = '';

    if (sizeIndex >= 0) {
      var dvSize = sliderEl.getAttribute('data-value-' + sizeIndex);
      if (dvSize) sizeVal = handleize(dvSize);
    }
    if (colorIndex >= 0) {
      var dvColor = sliderEl.getAttribute('data-value-' + colorIndex);
      if (dvColor) colorVal = handleize(dvColor);
    }

    if (!sizeVal && sizeIndex >= 0) sizeVal = getSelectedByIndex(sizeIndex);
    if (!colorVal && colorIndex >= 0) colorVal = getSelectedByIndex(colorIndex);

    if (!sizeVal && sliderEl.hasAttribute('data-size-value')) sizeVal = handleize(sliderEl.getAttribute('data-size-value'));
    if (!colorVal && sliderEl.hasAttribute('data-color-value')) colorVal = handleize(sliderEl.getAttribute('data-color-value'));

    var mapEnNo = parseMap(sliderEl.getAttribute('data-hc-map-en-no'));
    var mapNoEn = parseMap(sliderEl.getAttribute('data-hc-map-no-en'));

    colorVal = resolveTokenToSlides(wrapperEl, colorVal, mapEnNo, mapNoEn);

    filterSlides(wrapperEl, sizeVal, colorVal);

    if (sliderEl.__hcSwiper && sliderEl.__hcSwiper.destroy) sliderEl.__hcSwiper.destroy(true, true);
    sliderEl.__hcSwiper = initSwiper(sliderEl);

    if (sliderEl.__hcSwiper && sliderEl.__hcSwiper.update) {
      sliderEl.__hcSwiper.update();
      sliderEl.__hcSwiper.slideTo(0, false);
    }

    sliderEl.classList.remove('hc-loading');
    sliderEl.__hcBootOne = function () { bootOne(sliderEl); };
  }

  function refreshAll() {
    var sliders = document.querySelectorAll('.hc-main-slider-default');
    if (!sliders.length) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(sliders, function (sliderEl) {
          if (sliderEl && typeof sliderEl.__hcBootOne === 'function') sliderEl.__hcBootOne();
          else if (sliderEl) bootOne(sliderEl);
        });
      });
    });
  }

  window.hcCustomGalleryRefresh = refreshAll;

  function boot() {
    var sliders = document.querySelectorAll('.hc-main-slider-default');
    if (!sliders.length) return;
    Array.prototype.forEach.call(sliders, function (sliderEl) {
      bootOne(sliderEl);
    });

    ['variant:change', 'variant:select', 'variantChange'].forEach(function (evt) {
      document.addEventListener(evt, refreshAll);
    });

    document.addEventListener('change', function (e) {
      if (!e.target) return;
      if (!e.target.matches('input[name^="options"], select[name^="options"], input[data-variant-input], select[data-variant-input]')) return;
      refreshAll();
    });

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && (n.matches('.hc-main-slider-default') || n.querySelector('.hc-main-slider-default'))) {
            refreshAll();
            return;
          }
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();